import { Map } from "ol";
import React from "react";
import { useVehicles } from "~/pages/equipment-management-page/hooks/useEquipments";
import { PTOPFleetItemDto } from "~/pages/fleets-page/types";
import { useAppSelector } from "~/redux/store/store";
import { addVehicleEquipmentsToMap } from "../functions/addVehicleEquipmentsToMap";
import { vehicleEquipmentToMapItem } from "../functions/dataConverters";
import { findLayerByTitle } from "../functions/findLayerByTitle";
import { findSourceByTitle } from "../functions/findSourceByTitle";
import { LayerTitle } from "../types/layers";

export function useVehicleEquipmentsOnMap(
  map: Map | undefined,
  mapCreated: boolean,
) {
  const { vehicles } = useVehicles();

  const selectedMapFleet = useAppSelector((x) => x.fleet.selectedMapFleet);

  React.useEffect(() => {
    if (
      !map ||
      !mapCreated ||
      !findLayerByTitle(map, LayerTitle.VehicleEquipments)
    )
      return;
    addVehicleEquipmentsToMap(map, vehicles?.results ?? []);
  }, [vehicles, map, mapCreated]);

  React.useEffect(() => {
    if (
      !map ||
      !mapCreated ||
      !findLayerByTitle(map, LayerTitle.VehicleEquipments)
    )
      return;

    const equipmentMapItems = selectedMapFleet?.fleetItems
      ?.filter((x) => (x as PTOPFleetItemDto).item)
      .map((x) => vehicleEquipmentToMapItem((x as PTOPFleetItemDto).item));
    // Don't add items that belong to a selected fleet

    const filteredCars = equipmentMapItems
      ? vehicles?.results?.filter(
          (v) => !equipmentMapItems?.find((i) => i.id === v.id),
        )
      : vehicles?.results;

    addVehicleEquipmentsToMap(map, filteredCars ?? []);
    if (equipmentMapItems) {
      // Add to a separate fleet layer
      addVehicleEquipmentsToMap(map, equipmentMapItems);
    }
  }, [selectedMapFleet, vehicles?.results, map, mapCreated]);

  React.useEffect(() => {
    if (!map) return;
    if (!selectedMapFleet) {
      const layer = findLayerByTitle(map, LayerTitle.VehicleEquipments);

      if (layer) {
        const source = findSourceByTitle(map, LayerTitle.VehicleEquipments);
        if (source) {
          source.clear();
        }
      }
    }
  }, [map, selectedMapFleet]);
}
